import { LegalDoc } from "@frontend/components/site/legal-doc";
import { TERMS_META, TERMS_SECTIONS } from "@frontend/components/site/legal-data";
import { branding } from "@creators/backend/lib/config";
import { Seo } from "@frontend/lib/seo";

export function TermsPage() {
  return (
    <main>
      <Seo title={TERMS_META.title} description={TERMS_META.description} path={TERMS_META.path} />
      <LegalDoc
        eyebrow="Legal"
        title="Terms of Service"
        updated={TERMS_META.updated}
        intro={`${branding.name} helps you run collaborations. Collaboration money moves between you and the other party — we never hold it. Optional Serious and Priority fees are non-refundable platform charges.`}
        sections={TERMS_SECTIONS}
      />
    </main>
  );
}
